// A few BA-specific extras for Canvas contexts. One of these is a hack to
// fix fillText in firefox and requires Roboto to be loaded to work, so wait
// for Webfonts to load before running this.

const CanvasUtil = require("./util/CanvasUtil");
const Font = require("./util/Font");
const Shortvas = require("shortvas");

// Allow context.rect to accept {x, y, w, h} objects.
const allowObjInRect = function(origRect) {
	return function(...args) {
		const r = args[0];
		if (r && typeof r.x === "number" && typeof r.y === "number") {
			return origRect.call(this, r.x, r.y, r.w, r.h);
		}
		return origRect.apply(this, args);
	};
};

// Hack the Shortvas fillText method to try to fix Firefox's weird treatment
// of textBaseline. Run after WebFont is done.
const adjustFillText = function(origFillText) {
	return function(text, x, y) {
		const fontInfo = Font.toInfo(this);
		let shiftCoeff = 1 / 20; // Roboto and lizzie
		if (fontInfo.family.indexOf("Lora") > -1) {
			shiftCoeff = -3 / 50;
		} else if (fontInfo.family.indexOf("sans-serif") > -1) {
			shiftCoeff = 3 / 40;
		}
		if (this.textBaseline === "middle") {
			y += fontInfo.size * shiftCoeff;
		} else if (this.textBaseline === "top") {
			y += fontInfo.size * shiftCoeff * 2;
		}
		return origFillText.call(this, text, x, y);
	};
};

const isWeirdFillText = function(context) {
	context.clearRect(0, 0, 100, 100);
	context.font = "120px Roboto";
	context.fillStyle = "#FFF";
	context.textBaseline = "middle";
	context.fillText("T", 0, 52);
	// In Chrome, top pixel with text is at y=7. In Firefox, it is at y=1.
	const data = context.getImageData(20, 4, 1, 1).data;
	return data[0] > 0;
};

const calculateBlurAdjustment = function(context) {
	context.save();
	context.clearRect(0, 0, 100, 100);
	context.shadowBlur = 10;
	context.shadowColor = "#FFF";
	context.fillRect(0, 0, 10, 10);
	context.restore();
	//Find the highest y value where the shadow was drawn
	let maxShadowY = 11;
	while (
		maxShadowY < 100 &&
		context.getImageData(0, maxShadowY, 1, 1).data[0] > 0
	) {
		maxShadowY++;
	}
	//Chrome returns 19 and other browsers return 22, so we adjust their shadow blurs to match the look of Chrome.
	return 9 / (maxShadowY - 10);
};

//Hack in a setShadowBlur function that always multiplies the shadowBlur based on
//an adjustment value calculated initially with calculateBlurAdjustment as well
//as the current dpr as shadow drawing seems to vary for all browsers based on dpr.
//This function takes in the blur value that should be set and a second optional
//argument of options with a noAdjustment boolean option that should only be used
//for duplicating context values to another context.
const makeAdjustedSetShadowBlur = function(blurAdjustment) {
	return function(shadowBlur, opts = {}) {
		if (opts.noAdjustment) {
			this.context.shadowBlur = shadowBlur;
		} else {
			this.context.shadowBlur =
				shadowBlur * blurAdjustment * Math.min(CanvasUtil.getDPR(this), 1);
		}
	};
};

//This lets us verify that shadowBlur is only being set via the setShadowBlur function.
const setupShadowBlurTesting = function(shortvasContext) {
	if (process.env.NODE_ENV !== "production") {
		const proto = Object.getPrototypeOf(shortvasContext);
		Object.defineProperty(proto, "shadowBlur", {
			enumerable: true,
			configurable: true,
			get: function() {
				return this.context.shadowBlur;
			},
			set: function() {
				throw new Error("Can't set shadowBlur directly.");
			},
		});
	}
};

module.exports = function() {
	const canvas = CanvasUtil.createCanvas(100, 100, {
		source: "CanvasMods",
	});
	const context = CanvasUtil.getShortvas(canvas);

	const shortvasExtensions = {
		rect: allowObjInRect(context.rect),
		setShadowBlur: makeAdjustedSetShadowBlur(calculateBlurAdjustment(context)),
	};
	if (isWeirdFillText(context)) {
		shortvasExtensions.fillText = adjustFillText(context.fillText);
	}
	setupShadowBlurTesting(context);
	Shortvas.extend(shortvasExtensions);
	CanvasUtil.freeCanvasMemory(canvas, {
		source: "CanvasMods",
	});
};
